import { JobType } from "@repo/db/client";

//#region src/models/asyncJobFormatting.ts
function formatAsyncJobMessage(jobType, jobParams) {
	switch (jobType) {
		case JobType.Test: return "Running test task";
		case JobType.ReferralPriorAuth: {
			const params = jobParams;
			const firstName = params?.renderingProvider?.firstName ?? "provider";
			const lastName = params?.renderingProvider?.lastName ?? "";
			return `Submitting prior auth to ${lastName ? `${firstName} ${lastName}` : firstName}`;
		}
		case JobType.PullOpenReferrals: return `Syncing referrals from ${jobParams?.vendorName || "EHR"}`;
		case JobType.AttachRecordsSendReferral: {
			const params = jobParams;
			return `Sending referral to ${params?.referralRecipient?.name || "provider"}${!!params?.priorAuthorizationDetails ? " with prior auth" : ""}`;
		}
		case JobType.CheckEligibility: return `Checking eligibility for ${jobParams?.payorName || "insurance"} insurance`;
		case JobType.SearchProviders: {
			const params = jobParams;
			const specialty = params?.specialty;
			const locations = params?.locations;
			let searchDesc = "providers";
			if (specialty) searchDesc = `${specialty} specialists`;
			let locationStr = "";
			if (locations && locations.length > 0) locationStr = ` in ${locations.map((loc) => `${loc.city || ""}${loc.city && loc.state ? ", " : ""}${loc.state || ""}`).filter((str) => str.trim()).join(" or ")}`;
			return `Searching for ${searchDesc}${locationStr}`;
		}
		case JobType.CallProviders: {
			const params = jobParams;
			const receiver = params?.callReceiver || "provider";
			const phoneNumber = params?.phoneNumber || "";
			return `Calling ${receiver}${phoneNumber ? ` (${phoneNumber})` : ""}`;
		}
		case JobType.AgentNextStep: return "Agent processing";
		case JobType.SendSpruceMessage: return "Sending message to patient";
		default: return "Processing";
	}
}

//#endregion
export { formatAsyncJobMessage };